export const notificationConnectionLostBannerSx = {
  width: '100%',
  bgcolor: '#FEF3C7',
  borderBottom: '1px solid #FDE68A',
  px: 2,
  py: '8px',
  boxSizing: 'border-box',
} as const

export const notificationConnectionLostBannerInsetSx = {
  ...notificationConnectionLostBannerSx,
  borderBottom: 'none',
  borderRadius: '8px',
  mb: 1,
} as const

export const notificationConnectionLostTextSx = {
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '20px',
  color: '#92400E',
  textAlign: 'center',
} as const
